import useFractionStorageValue, {
  FractionStorageKey,
} from "./useFractionStorageValue";

export default function useCookieAccept(user) {
  const {
    value: areCookiesAccepted,
    updateValue: updateCookiesAccepted,
  } = useFractionStorageValue(user, FractionStorageKey.ALLOW_COOKIES);

  function accept() {
    updateCookiesAccepted(true);
  }

  function deny() {
    window.Jigsaw.User.signOut().then(() => window.location.reload());
  }

  return {
    areCookiesAccepted,
    accept,
    deny,
  };
}
